const instruments = {
  methods: {
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";
      textArea.style.width = "0px";
      textArea.style.height = "0px";
      textArea.style.overflow = "hidden";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (successful) {
          return true;
        }
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    },
    copyTextToClipboard(text, successMessage) {
      if (!navigator.clipboard) {
        if (successMessage) {
          this.$message.success(successMessage);
        }
        return this.fallbackCopyTextToClipboard(text);
      }
      navigator.clipboard.writeText(text).then(() => {
        if (successMessage) {
          this.$message.success(successMessage);
        }
        return true;
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    },
    async notifyRequestResult({ request, successMessage, methodOnSuccess, methodOnError }) {
      if (request.success) {
        this.$message.success(successMessage || request.message || 'Успешно');
        if (methodOnSuccess) {
          await methodOnSuccess();
        }
      } else {
        this.$message.error(`Ошибка: ${request.message || 'Неизвестная ошибка'}`);
        if (methodOnError) {
          await methodOnError();
        }
      }
    },
    isValidURL(url) {
      try {
        // Используем конструктор URL для проверки структуры URL
        new URL(url);
        return true;
      } catch (e) {
        return false;
      }
    },
    isValidBtcAddress(address) {
      return /^(?:[13][a-km-zA-HJ-NP-Z1-9]{25,34}|bc1[ac-hj-np-z02-9]{39,59})$/i.test(address);
    },
    isValidLtcAddress(address) {
      return /^(?:[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}|ltc1[ac-hj-np-z02-9]{39,59})$/i.test(address);
    },
  }
};

export default instruments;
